import { HeaderTextProps } from 'components/organisms/Header/types';

const header: HeaderTextProps = {
    headerText: {
        greetings: 'Hallo',
        intro: "Ich bin",
        preTitle: 'ein',
    },
    scrollDown: 'Nach unten scrollen',
};

export default header;
